// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import type { CurrentUser } from '../redux/main/reducers/currentUser';
import { setABExperimentBucket } from '../redux/main/actions/currentUser';

type OwnProps = {
  experimentId: string,
  defaultBucket: string,
  render: (bucket: string) => React.Node,
  initializeWithDefault?: boolean
};

type Props = {
  ...$Exact<OwnProps>,
  currentUser?: CurrentUser,
  setABExperimentBucket: Function
};

type State = {
  bucket: ?string
};

class ABExperiment extends React.PureComponent<Props, State> {
  state = {
    bucket: this.props.initializeWithDefault ? this.props.defaultBucket : null
  };

  componentDidMount() {
    const { currentUser, experimentId, defaultBucket } = this.props;

    if (currentUser && currentUser.isLoaded && currentUser.abExperiments) {
      let experiment = currentUser.abExperiments.find(
        e => e.id === experimentId
      );
      if (experiment) {
        this.setState({ bucket: experiment.bucket });
        return;
      }
      this.props.setABExperimentBucket(experimentId).then(abExperiments => {
        experiment = abExperiments.find(e => e.id === experimentId);
        if (experiment) {
          this.setState({ bucket: experiment.bucket });
          return;
        }
        this.setState({ bucket: defaultBucket });
      });
    }
  }

  render() {
    if (!this.state.bucket) {
      return null;
    }
    return this.props.render(this.state.bucket);
  }
}

const mapStateToProps = ({ currentUser }) => ({ currentUser });

export default connect<Props, OwnProps, _, _, _, _>(
  mapStateToProps,
  { setABExperimentBucket }
)(ABExperiment);
